import { css, createGlobalStyle } from 'styled-components';
import fontProximaSizeLineHeight from './fontProximaSizeLineHeight';
import proximaRegular from './fonts/ProximaNova-Regular.woff2';
import proximaMedium from './fonts/ProximaNova-Medium.woff2';
import proximaSemibold from './fonts/ProximaNova-Semibold.woff2';

const fontSizeLineHeight = {
  headerH1: [28, 42],
  subheadH2: [24, 36],
  subheadH3: [20, 30],
  subheadH4: [18, 27],
  numbers36: [36, 54],
  numbers28: [28, 42],
  numbers24: [24, 36],
  numbers20: [20, 30],
  paragraph16: [16, 24],
  paragraph14: [14, 21],
  paragraph12: [12, 18],
  paragraph10: [10, 16],
  paragraph8: [8, 12],
  paragraph6: [6, 9],
  captionLarge: [16, 24],
  captionMedium: [14, 21],
  captionSmall: [12, 18],
  button16: [16, 24],
  button14: [14, 20],
  button12: [12, 18],
  button10: [10, 14],
  button8: [8, 12],
  button6: [6, 9],
  linkLarge: [16, 24],
  linkMedium: [14, 21],
  chartesdata: [14, 24],
};

export const [
  headerH1,
  subheadH2,
  subheadH3,
  subheadH4,
  numbers36,
  numbers28,
  numbers24,
  numbers20,
  paragraph16,
  paragraph14,
  paragraph12,
  paragraph10,
  paragraph8,
  paragraph6,
  captionLarge,
  captionMedium,
  captionSmall,
  button16,
  button14,
  button12,
  button10,
  button8,
  button6,
  linkLarge,
  linkMedium,
  chartesdata,
] = Object.keys(fontSizeLineHeight).map(
  (fontName) => css`
    font-family: Poppins, sans-serif;
    font-size: var(--${fontName}Size);
    line-height: var(--${fontName}Height);
  `,
);

export const [H1, H2, H3, H4, H5, body1, body2, body3, caption, tinny] =
  Object.keys(fontProximaSizeLineHeight).map(
    (fontName) => css`
      font-family:
        Proxima Nova,
        sans-serif;
      font-size: var(--${fontName}Size);
      line-height: var(--${fontName}Height);
    `,
  );

export const [regular, medium, semibold, bold] = [
  'regular',
  'medium',
  'semibold',
].map(
  (weight) => css`
    font-weight: var(--${weight});
  `,
);

export default createGlobalStyle`
  ${css`
    :root {
      ${Object.entries(fontSizeLineHeight)
        .map(
          ([fontName, [fontSize, fontHeight]]) =>
            `--${fontName}Size: ${fontSize}px;--${fontName}Height: ${fontHeight}px;`,
        )
        .join(' ')}
      ${Object.entries(fontProximaSizeLineHeight)
        .map(
          ([fontName, [fontSize, fontHeight]]) =>
            `--${fontName}Size: ${fontSize}px;--${fontName}Height: ${fontHeight}px;`,
        )
        .join(' ')}
      --regular: 400;
      --medium: 500;
      --semibold: 600;
    }
    @font-face {
      font-family: 'Proxima Nova';
      src: url('${proximaRegular}') format('woff2');
      font-weight: 400;
      font-style: normal;
    }
    @font-face {
      font-family: 'Proxima Nova';
      src: url('${proximaMedium}') format('woff2');
      font-weight: 500;
      font-style: normal;
    }
    @font-face {
      font-family: 'Proxima Nova';
      src: url('${proximaSemibold}') format('woff2');
      font-weight: 600;
      font-style: normal;
    }
  `}
`;
